import { EmailAuthenticationMethodConfiguration } from '@microsoft/microsoft-graph-types-beta';
import { AuthenticationMethodsEmailOTPSchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/email-otp/model';
import { updateAuthenticationMethodPolicyConfig } from 'projects/angular-clarity/src/app/stores/client/graph/authentication-methods-policies/actions';

export function remediate(
    _tenant: string,
    policy: EmailAuthenticationMethodConfiguration,
    schema: AuthenticationMethodsEmailOTPSchema,
) {
    const updatedPolicy: EmailAuthenticationMethodConfiguration = {
        ...policy,
        state: schema.properties.state.const,
    };

    // If state is disabled, only send the state field
    if (schema.properties.state.const === 'disabled') {
        return updateAuthenticationMethodPolicyConfig({
            _tenant,
            policy: updatedPolicy,
        });
    }

    // If state is enabled, include all other fields
    updatedPolicy.allowExternalIdToUseEmailOtp = schema.properties.allowExternalIdToUseEmailOtp.const;

    if (schema.properties.includeTargets.maxItems > 0) {
        updatedPolicy.includeTargets = schema.properties.includeTargets.items.oneOf.map((target) => {
            return {
                id: target.properties.id.const,
                targetType: target.properties.targetType.const,
            };
        });
    } else {
        updatedPolicy.includeTargets = [];
    }

    if (schema.properties.excludeTargets.maxItems > 0) {
        updatedPolicy.excludeTargets = schema.properties.excludeTargets.items.oneOf.map((target) => {
            return {
                id: target.properties.id.const,
                targetType: target.properties.targetType.const,
            };
        });
    } else {
        updatedPolicy.excludeTargets = [];
    }

    return updateAuthenticationMethodPolicyConfig({
        _tenant,

        policy: updatedPolicy,
    });
}
